// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var PriceLimitMeasure;
(function (PriceLimitMeasure) {
    PriceLimitMeasure[PriceLimitMeasure["DISABLE"] = -1] = "DISABLE";
    PriceLimitMeasure[PriceLimitMeasure["PERCENTAGE_SETTL_PRICE"] = 0] = "PERCENTAGE_SETTL_PRICE";
    PriceLimitMeasure[PriceLimitMeasure["OFFSET_SETTL_PRICE"] = 1] = "OFFSET_SETTL_PRICE";
    PriceLimitMeasure[PriceLimitMeasure["INDICATIVE_PRICES"] = 2] = "INDICATIVE_PRICES";
    PriceLimitMeasure[PriceLimitMeasure["EXCHANGE_LIMITS"] = 3] = "EXCHANGE_LIMITS";
    PriceLimitMeasure[PriceLimitMeasure["PERCENTAGE_PREV_CLOSE_PRICE"] = 4] = "PERCENTAGE_PREV_CLOSE_PRICE";
    PriceLimitMeasure[PriceLimitMeasure["OFFSET_PREV_CLOSE_PRICE"] = 5] = "OFFSET_PREV_CLOSE_PRICE";
    PriceLimitMeasure[PriceLimitMeasure["PERCENTAGE_CHANGE_FROM_REFERENCE_PRICE"] = 6] = "PERCENTAGE_CHANGE_FROM_REFERENCE_PRICE";
    PriceLimitMeasure[PriceLimitMeasure["FRONT_END_VALIDATION"] = 8] = "FRONT_END_VALIDATION";
})(PriceLimitMeasure || (PriceLimitMeasure = {}));
